export enum BundleDiscountType {
  bundle2 = "bundle2",
  bundle3 = "bundle3",
  bundle4 = "bundle4",
  bundle5 = "bundle5",
  bundle6 = "bundle6",
  BuyGet = "buygetbundle",
  // New dynamic bundle types
  BuyXGetY = "buyXgetY", // e.g., Buy 4 Get 2 free
  BuyXGetYPercent = "buyXgetYpercent", // e.g., Buy 3 Get 50% off 1
  PercentageOff = "percentageOff", // Standard percentage off all items
  NthItemDiscount = "nthItemDiscount", // Discount on specific positioned item
}
